module.exports = __webpack_public_path__ + "static/media/pos_check_button.460c46d3.png";